import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ticketViewCommentsPart',
  standalone: false,
})
export class TicketViewPipeCommentsPart implements PipeTransform {
  transform(value: any, mode: any): any {
    return mode === 'collapsed' ? [value[0]] : value;
  }
}
